import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components/base';

import { Picture, Responsive, SectionHead, imageShape } from '../landing/shared';

// Letter paper first as the reference sheet, then the calendars at the same scale. The drawing
// itself is decorative, the names and sizes under it carry the information.
const SCALE = [
  { name: 'Letter paper', short: 'Letter', dims: '8.5x11 in', inches: [8.5, 11], reference: true },
  { name: 'Keepsake', dims: '8.25x12 in', inches: [8.25, 12] },
  { name: 'Large', dims: '11x17 in', inches: [11, 17] },
  { name: 'Engineer Print', short: 'Engineer', dims: '3x4 ft', inches: [36, 48] },
];

const UpClose = ({ photo, details }) => (
  <section className="lnd-section cal-up-close">
    <Container>
      <SectionHead
        eyebrow="Size, paper and print"
        title="What you get, up close"
        aside={
          <span className="lnd-desk">
            Real photos of the calendars we print. Each detail below names the format it belongs to.
          </span>
        }
      />
      <div className="cal-scale-row">
        <div className="cal-scale">
          <div>
            <p className="cal-scale-title">All three, drawn to scale</p>
            <p className="cal-scale-sub">
              <Responsive
                desktop="Next to a letter-size sheet of paper, 8.5x11 in."
                phone="Next to a letter-size sheet, 8.5x11 in."
              />
            </p>
          </div>
          <ul className="cal-scale-lane">
            {SCALE.map(({ name, short, dims, inches, reference }) => (
              <li key={name} className={reference ? 'cal-scale-item reference' : 'cal-scale-item'}>
                <span
                  className="cal-scale-shape"
                  style={{ '--w': inches[0], '--h': inches[1] }}
                  aria-hidden="true"
                />
                <span className="cal-scale-name">
                  <Responsive desktop={name} phone={short} />
                </span>
                <span className="cal-scale-dims">{dims}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="cal-scale-photo">
          <Picture image={photo} sizes="(min-width: 992px) 560px, 100vw" />
        </div>
      </div>
      <ul className="cal-details">
        {details.map((detail) => (
          <li key={detail.title}>
            <span className="cal-detail-photo">
              <Picture image={detail.image} sizes="(min-width: 992px) 282px, 50vw" />
            </span>
            <p className="cal-detail-tag">{detail.tag}</p>
            <h3 className="cal-detail-title">{detail.title}</h3>
            <p className="cal-detail-body">{detail.body}</p>
          </li>
        ))}
      </ul>
    </Container>
  </section>
);

UpClose.propTypes = {
  photo: imageShape.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
      image: imageShape.isRequired,
    }),
  ).isRequired,
};

export default UpClose;
